<template>
  <div>
    <div v-if="benchmark">
      <div class="range-bar">
        <div class="value-element" :style="markerPosition"></div>
        <div
          class="range-element"
          v-for="(range, index) in benchmarkWidths"
          :key="'range-' + index"
          :style="benchmarkWidths[index].style"
          :class="{
            active:
              parseInt(marker.value) > range.prevVal &&
              parseInt(marker.value) < range.value
          }"
        >
          <div>{{ range.title }}</div>
          <div>{{ range.prevVal }}-{{ range.value }}</div>
        </div>
      </div>
    </div>
    <div v-else>
      No benchmarking data available.
    </div>
  </div>
</template>

<script>
export default {
  props: {
    marker: {
      type: Object,
      required: true
    }
  },
  methods: {},
  computed: {
    benchmarkValueTitle() {
      return "Acceptable";
    },
    benchmark() {
      return this.$store.getters["TestsStore/benchmarkSingle"](this.marker.id);
    },
    benchmarkMax() {
      return this.benchmark.range[this.benchmark.range.length - 1].value;
    },
    markerPosition() {
      return { left: (100 * this.marker.value) / this.benchmarkMax + "%" };
    },
    benchmarkWidths() {
      var rBenchmarks = [];
      var acc = 0;
      var prevVal = 0;
      const max = parseInt(this.benchmarkMax);
      this.benchmark.range.forEach((benchmark, index) => {
        const val = parseInt(benchmark.value);
        const nextVal = this.benchmark.range[index + 1]
          ? parseInt(this.benchmark.range[index + 1].value)
          : val;
        if (index > 0)
          rBenchmarks.push({
            style: {
              left: (100 * prevVal) / max + "%",
              right: (100 * (max - val)) / max + "%"
            },
            value: val,
            prevVal,
            nextVal,
            title: benchmark.title,
            index,
            acc
          });
        acc += val;
        prevVal = val;
      });
      return rBenchmarks;
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../styles/vars";
.range-bar {
  display: block;
  position: relative;
  height: @h4;
  width: 100%;
  .value-element {
    position: absolute;
    width: 5px;
    border-radius: 3px;
    top: -@hh;
    bottom: -@hh;
    background-color: #f00;
    z-index: 10;
    transform: translateX(-50%);
  }
  .range-element {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    position: absolute;
    height: 100%;
    font-size: 14px;
    background-color: #fff;
    border-left: 1px solid #aaa;
    padding-left: @hh;
    // outline: 1px solid #f00;
    z-index: 5;
    overflow: hidden;
    &.active {
      background-color: #333;
      color: #fff;
      font-weight: 600;
    }
    > div {
      overflow: visible;
      white-space: nowrap;
    }
  }
}
</style>
